import { useMemo } from 'react';

export const useSearchedData = ({ data, searchQuery }) =>
  useMemo(() => {
    if (!data) {
      return [];
    }

    const queryKey = searchQuery.toUpperCase();
    return searchQuery.length
      ? data.filter(({ name }) => name.toUpperCase().includes(queryKey))
      : data;
  }, [data, searchQuery]);
